import React from 'react'
import { DateRangePicker } from '../../_library/DateRangePicker'
import LoadingBar from '../../_library/LoadingBar'
import SortableTable from '../../_library/SortableTable/index'
import EmptyBar from '../../_library/EmptyBar'
import { getTableColumns } from '../../utils/sortableTableUtils'
import { formatDay, formatDateTime, defaultDateFormat } from '../../../_common/core/validation/normalizers'
import { SaveTemplate, SelectFilterTemplate } from '../../_library/FilterTemplate'
import CardHeader from '../../_library/CardHeader'
import TrafficViewChart from './components/TrafficViewChart'
import { Chart } from '../../_library/Chart'
import { connect } from 'react-redux'
import { FETCH_EVENT_TRAFFIC } from '../../../_common/redux/performance/actions'
import moment from 'moment'
import _groupBy from 'lodash/groupBy'
import _isEqual from 'lodash/isEqual'
import _map from 'lodash/map'
import { showAxiosError } from '../../utils/messenger'
import { fetchEventTrafficSubtable, fetchEventTrafficTable } from '../../../_common/core/http_services/events'
import { DATE_TRAFFIC_SUPPORT } from '../performance/constants/constants'
import ProgressCircle from '../../_library/ProgressCircle'

@connect(null, { FETCH_EVENT_TRAFFIC })
export default class TrafficViews extends React.PureComponent {
  constructor(props) {
    super(props)
    this.tableColumns = getTableColumns([
      {
        key: 'createdAt',
        label: 'View Date',
        isSortable: true,
        normalizer: formatDay
      },
      {
        key: 'total',
        label: 'No. of Visits',
        isSortable: true
      },
      {
        key: 'directVisits',
        label: 'No. of Direct Visits',
        isSortable: true
      },
      {
        key: 'referralVisits',
        label: 'No. of Referral Visits',
        isSortable: true
      },
      //TODO: Ritesh will clarify RAW formula
      /*{
        key: 'rawVisits',
        label: 'No. of Raw Visits',
        isSortable: true
      }, */
      {
        key: 'uniqueVisits',
        label: 'No. of Unique Visits',
        isSortable: true
      }
    ])

    this.detailsTableColumns = getTableColumns([
      {
        key: 'createdAt',
        label: 'View Hour',
        className: 'detail-cell',
        isSortable: true,
        normalizer: formatDateTime
      },
      {
        key: 'total',
        label: 'No. of Visits',
        className: 'detail-cell',
        isSortable: true
      },
      {
        key: 'directVisits',
        label: 'No. of Direct Visits',
        className: 'detail-cell',
        isSortable: true
      },
      {
        key: 'referralVisits',
        label: 'No. of Referral Visits',
        className: 'detail-cell',
        isSortable: true
      },
      //TODO: Ritesh will clarify RAW formula
      /* {
        key: 'rawVisits',
        label: 'No. of Raw Visits',
        className: 'detail-cell',
        isSortable: true
      }, */
      {
        key: 'uniqueVisits',
        label: 'No. of Unique Visits',
        className: 'detail-cell',
        isSortable: true
      }
    ])

    this.footbarColumns = [
      { key: 'total', sourceKey: 'total' },
      { key: 'directVisits', sourceKey: 'directVisits' },
      { key: 'referralVisits', sourceKey: 'referralVisits' },
      { key: 'rawVisits', sourceKey: 'rawVisits' },
      { key: 'uniqueVisits', sourceKey: 'uniqueVisits' }
    ]

    this.state = {
      startDate: null,
      endDate: null,
      sortBy: { column: 'createdAt', asc: false },
      sortBySubTable: { column: 'createdAt', asc: true },
      filterUpdateVersion: 0,
      isLoading: true,
      raw: [],
      hourly: [],
      time: 'day',
      detailsRows: []
    }

    this.raw = []
    this.mounted = true
    this.trafficInterval = null
  }

  componentDidMount() {
    this.fetchTraffic()
    this.trafficInterval = setInterval(() => {
      this.fetchTraffic()
    }, 600 * 1000)
  }

  componentWillUnmount() {
    this.mounted = false
    clearInterval(this.trafficInterval)
  }

  onDateRangeApply = (startDate, endDate) => {
    this.setState({ startDate, endDate, isLoading: true }, () => {
      this.fetchTraffic()
    })
  }

  onDateRangeClear = () => {
    this.setState({ startDate: null, endDate: null, isLoading: true }, () => {
      this.fetchTraffic()
    })
  }

  isEmptyChecker = data => {
    const { startDate, endDate } = data
    return !(startDate && endDate)
  }

  onSaveFilter = () => {
    this.setState(s => ({ filterUpdateVersion: s.filterUpdateVersion + 1 }))
  }

  onSelectFilter = template => {
    let { value } = template
    try {
      value = JSON.parse(value)
      const { startDate, endDate } = value
      this.onDateRangeApply(moment(startDate), moment(endDate))
    } catch (e) {
      showAxiosError(e)
    }
  }

  fetchTraffic = async () => {
    const { FETCH_EVENT_TRAFFIC, event, showWarning, setShowWarning } = this.props
    const { time, startDate, endDate, raw: stateRaw, hourly: stateHourly, isLoading } = this.state
    try {
      const dates =
        startDate && endDate
          ? { date_from: startDate.format('YYYY-MM-DD'), date_to: endDate.format('YYYY-MM-DD') }
          : {}
      const hourlyRaw = await fetchEventTrafficTable(event.id, { ...dates })
      let total = 0
      let rawVisits = 0
      let uniqueVisits = 0
      let directVisits = 0
      let referralVisits = 0
      hourlyRaw.forEach(row => {
        row.id = moment(row.createdAt, defaultDateFormat).format('YYYY-MM-DD')
        total += Number(row.total)
        referralVisits += Number(row.referralVisits)
        uniqueVisits += Number(row.uniqueVisits)
      })
      rawVisits = total - uniqueVisits
      directVisits = total - referralVisits
      const raw = (await FETCH_EVENT_TRAFFIC(event.id, { group_by: [time], page: 'event', ...dates })) ?? []
      if (this.raw.length === 0) {
        this.raw = raw
      }
      if (_isEqual(raw, stateRaw) && _isEqual(hourlyRaw, stateHourly) && !isLoading) {
        return
      }
      if (!showWarning) {
        if (
          raw.find(row =>
            moment(row.created_at, defaultDateFormat).isBefore(
              moment(DATE_TRAFFIC_SUPPORT, defaultDateFormat)
            )
          )
        ) {
          setShowWarning()
        }
      }
      if (!this.mounted) return
      this.setState({
        raw,
        hourly: hourlyRaw,
        isLoading: false,
        rawVisits,
        referralVisits,
        uniqueVisits,
        directVisits
      })
    } catch (err) {
      showAxiosError(err)
    }
  }

  getPercentage = (total, value) => Math.round((value * 100) / total)

  getDetailRowData = async data => {
    const dateFormated = moment(data.createdAt, defaultDateFormat).format('YYYY-MM-DD')
    const { event } = this.props
    const uniqueHours = await fetchEventTrafficSubtable(event.id, dateFormated)
    const groups = _groupBy(uniqueHours, row =>
      moment(row.createdAt, defaultDateFormat).format('YYYY-MM-DD h:[00] a')
    )
    const groupsResult = _map(groups, rows => {
      const newDetailRow = {
        total: 0,
        rawVisits: 0,
        uniqueVisits: 0,
        directVisits: 0,
        referralVisits: 0,
        createdAt: rows[0].createdAt
      }
      rows.forEach(row => {
        newDetailRow.total += Number(row.total)
        newDetailRow.referralVisits += Number(row.referralVisits)
        newDetailRow.uniqueVisits++
      })
      newDetailRow.rawVisits = newDetailRow.total - newDetailRow.uniqueVisits
      newDetailRow.directVisits = newDetailRow.total - newDetailRow.referralVisits
      return newDetailRow
    })
    const detailsRows = [
      {
        id: dateFormated,
        type: 'detailRow',
        component: (
          <SortableTable
            data={groupsResult}
            tableColumns={this.detailsTableColumns}
            enableSort={true}
            enableCopyTable={true}
            disableMobileView={true}
            className="child-table"
            sortBy={this.state.sortBySubTable}
          />
        )
      }
    ]
    this.setState({
      detailsRows
    })
    return true
  }

  changeTime = time => {
    this.setState({ time, isLoading: true }, () => {
      this.fetchTraffic()
    })
  }

  render() {
    const { event } = this.props
    const {
      startDate,
      endDate,
      sortBy,
      filterUpdateVersion,
      isLoading,
      raw,
      time,
      hourly,
      referralVisits,
      directVisits,
      uniqueVisits,
      rawVisits,
      detailsRows
    } = this.state
    const showSaveTemplateBtn = startDate && endDate

    const countState = raw.length

    const count = this.raw.length

    const chart1Total = uniqueVisits + rawVisits
    const chart2Total = directVisits + referralVisits
    const referralVisitsPercent = this.getPercentage(chart2Total, referralVisits)
    const directVisitsPercent = this.getPercentage(chart2Total, directVisits)
    // TODO: Ritesh will clarify RAW formula
    //const rawVisitsPercent = this.getPercentage(chart1Total, rawVisits)
    const uniqueVisitsPercent = this.getPercentage(chart1Total, uniqueVisits)

    return (
      <div ref="cardContainer" className="performance-sales traffic-views">
        <CardHeader imageUrl="/resources/images/event/performance/ticket-sales-ico.svg" bodyText="Views" />
        <div className="table-background">
          {isLoading ? (
            <LoadingBar title={"Hold tight! We're getting your statistics..."} />
          ) : this.raw.length === 0 ? (
            <EmptyBar />
          ) : (
            <div>
              <TrafficViewChart traffic={raw} changeTime={this.changeTime} time={time} />
              {countState !== 0 ? (
                <div className="event-traffic-circles">
                  <div style={{ width: '600px' }} className="event-traffic-circle">
                    <div className="col-xs-12 col-sm-4 blue-circle">
                      <ProgressCircle value={directVisitsPercent} />
                      <div className="circle-info">
                        <div className="circle-description">
                          <div className="description1">
                            <div className="circle-value">{directVisits}</div>
                            <div className="circle-type">Direct Visits</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 pink-circle">
                      <ProgressCircle value={referralVisitsPercent} />
                      <div className="circle-info">
                        <div className="circle-description">
                          <div className="description1">
                            <div className="circle-value">{referralVisits}</div>
                            <div className="circle-type">Referral Visits</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style={{ width: '600px' }} className="event-traffic-circle">
                    {/* TODO Ritesh will clarify RAW formula
                    <div className="col-xs-12 col-sm-4 blue-circle">
                      <ProgressCircle value={rawVisitsPercent} />
                      <div className="circle-info">
                        <div className="circle-description">
                          <div className="description1">
                            <div className="circle-value">{rawVisits}</div>
                            <div className="circle-type">Raw Visits</div>
                          </div>
                        </div>
                      </div>
                    </div> */}
                    <div className="col-xs-12 col-sm-4 pink-circle">
                      <ProgressCircle value={uniqueVisitsPercent} />
                      <div className="circle-info">
                        <div className="circle-description">
                          <div className="description1">
                            <div className="circle-value">{uniqueVisits}</div>
                            <div className="circle-type">Unique Visits</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
              {count > 0 && (
                <div className="row performance-sales-daterange">
                  <div className="col-sm-8 col-xs-12">
                    <div
                      style={{ display: 'inline-block', marginTop: 10, marginBottom: 10, marginRight: 10 }}
                    >
                      <DateRangePicker
                        onApply={this.onDateRangeApply}
                        onClear={this.onDateRangeClear}
                        value={{ startDate, endDate }}
                      />
                    </div>
                    {showSaveTemplateBtn ? (
                      <div style={{ margin: '10px 0px', display: 'inline-block' }}>
                        <SaveTemplate
                          data={{
                            startDate,
                            endDate
                          }}
                          isEmptyChecker={this.isEmptyChecker}
                          storagePath={`event-${event.id}-performance-ticket-sales-filter`}
                          onSaveFilter={this.onSaveFilter}
                        />
                      </div>
                    ) : null}
                  </div>
                  <div
                    className="col-sm-4 col-xs-12"
                    style={{ margin: '10px 0', textAlign: isMobileDevice() ? 'start' : 'end' }}
                  >
                    <SelectFilterTemplate
                      storagePath={`event-${event.id}-performance-ticket-sales-filter`}
                      onSelectFilter={this.onSelectFilter}
                      updateVersion={filterUpdateVersion}
                    />
                  </div>
                </div>
              )}
              <SortableTable
                isAsyncDetails
                data={hourly}
                tableColumns={this.tableColumns}
                enableSort={true}
                enableCopyTable={true}
                disableMobileView={true}
                sortBy={sortBy}
                detailsRows={detailsRows}
                getDetailRowData={this.getDetailRowData}
                footbar={{
                  label: 'Total',
                  columns: this.footbarColumns
                }}
              />
            </div>
          )}
        </div>
      </div>
    )
  }
}
